<template>
    <div>
        <v-row>
            <v-col>
                <v-card>
                    <meetings-card-title title="Overskredne åbne møder" :count="overdueMeetings.length" />
                    <loader v-if="loading || !(salesAgents.length > 0)" />
                    <div v-else>
                        <v-subheader class="pa-0">
                            <v-col v-for="(header, index) in $store.state.meetings.meetingHeaders" :key="index" :cols="header.cols" class="text-center">
                                {{ header.header }}
                            </v-col>
                        </v-subheader>
                        <meeting v-for="meeting in paginatedOverdueMeetings" :key="meeting.id" :initialMeeting="meeting" @meetingDeleted="getData"/>
                    </div>
                    <v-row v-if="overdueMeetings.length > itemsPerPage">
                        <v-col>
                            <v-pagination
                                v-model="overduePage"
                                @input="paginateOverdueMeetings"
                                :length="Math.ceil(overdueMeetings.length / itemsPerPage)"
                                :total-visible="10"
                            />
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <br />
        <v-row>
            <v-col>
                <v-card>
                    <meetings-card-title title="Åbne møder i dag" :count="currentMeetings.length" />
                    <loader v-if="loading || !(salesAgents.length > 0)" />
                    <div v-else>
                        <v-subheader class="pa-0">
                            <v-col v-for="(header, index) in $store.state.meetings.meetingHeaders" :key="index" :cols="header.cols" class="text-center">
                                {{ header.header }}
                            </v-col>
                        </v-subheader>
                        <meeting v-for="meeting in paginatedCurrentMeetings" :key="meeting.id" :initialMeeting="meeting" @meetingDeleted="getData" />
                    </div>
                    <v-row v-if="currentMeetings.length > itemsPerPage">
                        <v-col>
                            <v-pagination
                                v-model="currentPage"
                                @input="paginateCurrentMeetings"
                                :length="Math.ceil(currentMeetings.length / itemsPerPage)"
                                :total-visible="10"
                            />
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from 'moment'
import meeting from '@/views/Booking/Components/meeting'
import meetingsCardTitle from '@/views/Booking/Components/meetingsCardTitle'

export default {
    components: {
        meeting,
        meetingsCardTitle
    },
    data () {
        return {
            currentPage: 1,
            overduePage: 1,
            itemsPerPage: 7,
            loading: true,
            currentMeetings: [],
            overdueMeetings: [],
            paginatedOverdueMeetings: [],
            paginatedCurrentMeetings: []
        }
    },
    computed: {
        salesAgent () {
            return this.$store.state.meetings.salesAgent
        },
        salesAgents () {
            return this.$store.state.meetings.salesAgents
        },
        changes () {
            return this.$store.state.meetings.changes
        },
        team () {
            return this.$store.state.meetings.team
        }
    },
    methods: {
        paginateCurrentMeetings() {
            this.paginatedCurrentMeetings = [...this.currentMeetings].splice(this.itemsPerPage * (this.currentPage - 1), this.itemsPerPage)
        },
        paginateOverdueMeetings() {
            this.paginatedOverdueMeetings = [...this.overdueMeetings].splice(this.itemsPerPage * (this.overduePage - 1), this.itemsPerPage)
        },
        async getData () {
            this.loading = true
            this.$store.state.meetings.changedMeetings = false
            let team, department
            if (this.$store.state.meetings.team === 'Alle teams') {
                team = null
            } else if (this.$store.state.meetings.team === 'tryg') {
                department = 'tryg'
            } else if (this.$store.state.meetings.team === 'alka') {
                department = 'alka'
            } else {
                team = this.$store.state.meetings.team
            }
            let response = await this.$http().get('/booking/registration/currentMeetings', {
                params: {
                    department,
                    team,
                    salesAgent: this.$store.state.meetings.salesAgent,
                    today: moment().format('YYYY-MM-DD')
                }
            })
            this.currentMeetings = response.data.currentMeetings.map(meeting => {
                const mappedMeeting = {
                    ...meeting,
                    meetingTime: moment(meeting.meetingTime).subtract(1, 'hour').format('HH:mm')
                }
                return {
                    ...mappedMeeting
                }
            })
            this.overdueMeetings = response.data.overdueMeetings.map(meeting => {
                const mappedMeeting = {
                    ...meeting,
                    meetingTime: moment(meeting.meetingTime).subtract(1, 'hour').format('HH:mm')
                }
                return {
                    ...mappedMeeting
                }
            })
            this.paginateCurrentMeetings()
            this.paginateOverdueMeetings()
            this.loading = false
        },
    },
    watch: {
        range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
		},
        $route: function () {
            this.$store.commit('meetings/setFilters', this.route)
            this.getData()
        },
        period: function () {
		    this.$store.commit("meetings/setRange", this.$store.state.meetings.period);
        },
        changes: function () {
            this.getData()
        },
        team: function () {
            this.getData()
        },
        salesAgent: function () {
            this.getData()
        }
    },
    created () {
        this.$store.state.meetings.updatedMeetings = {}
        this.$store.state.meetings.period = 'I dag'
        this.$store.state.meetings.searchString = null
        if (this.$store.state.main.access === 'tele' && this.salesAgent) this.getData()
        else if (this.$store.state.main.access !== 'tele') this.getData()
    }
}
</script>